import React, { useState } from 'react';
import { Box, Container, Typography, Stack, Link, IconButton, Dialog, DialogContent, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const TopBar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const contactContent = (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center">
            <Link href="tel:+919845374571" underline="none" color="inherit" sx={{ '&:hover': { color: 'primary.main' } }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <PhoneIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                    <Typography variant="body1" sx={{ fontSize: '14px', lineHeight: 1.75 }}>
                        +91 98453 74571
                    </Typography>
                </Stack>
            </Link>

            <Link
                href="mailto:info@4mhenterprises.com"
                underline="none"
                color="inherit"
                sx={{
                    '&:hover': {
                        color: 'primary.main'
                    },
                    cursor: 'pointer'
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <EmailIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '14px',
                            lineHeight: 1.75
                        }}
                    >
                        info@4mhenterprises.com
                    </Typography>
                </Stack>
            </Link>

            <Link href="https://www.google.com/maps/search/Ground+Floor,+No.44,+C1,+4th+Main+Road,+Jaraganahalli,+Ilyas+Nagar,+J.P.+Nagar+Post,+Bangalore+-+560078,+Karnataka,+India/@12.905687,77.5737378,16z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener" underline="none" color="inherit" sx={{ '&:hover': { color: 'primary.main' } }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <LocationOnIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                    <Typography variant="body1" sx={{ fontSize: '14px', lineHeight: 1.75 }}>
                        J.P. Nagar Post, Bangalore
                    </Typography>
                </Stack>
            </Link>
        </Stack>
    );

    const hoursContent = (
        <Stack direction="row" spacing={1} alignItems="center">
            <AccessTimeIcon sx={{ fontSize: 16, color: 'primary.main' }} />
            <Typography variant="body1" sx={{ fontSize: '14px' }}>
                Mon - Sat: 9:00 AM - 7:00 PM
            </Typography>
        </Stack>
    );

    return (
        <Box
            sx={{
                bgcolor: '#212327',
                color: '#ffffff',
                py: 1.8,
                fontSize: '13px',
            }}
        >
            <Container>
                {isMobile ? (
                    // Mobile View
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} onClick={handleOpen} sx={{ cursor: 'pointer' }}>
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600 }}>TopBar</Typography>
                        <IconButton size="small" sx={{ color: 'primary.main' }}>
                            <MenuIcon />
                        </IconButton>
                    </Stack>
                ) : (
                    // Desktop View
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                    >
                        {/* Left Side: Contact Info */}
                        {contactContent}

                        {/* Right Side: Hours */}
                        {hoursContent}
                    </Stack>
                )}

                {/* Mobile Popup Dialog */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        sx: {
                            bgcolor: '#212327',
                            color: 'white',
                            minWidth: '300px',
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'primary.main'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                        <IconButton onClick={handleClose} sx={{ color: 'white' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <DialogContent sx={{ p: 0 }}>
                        <Stack spacing={3} alignItems="flex-start">
                            {contactContent}
                            {hoursContent}
                        </Stack>
                    </DialogContent>
                </Dialog>
            </Container>
        </Box>
    );
};

export default TopBar;
